import moment from "moment";

// Add these functions to your utils/date.ts or directly in your component

// Convert seconds to HH:mm format (24-hour)
export const convertSecondsToTimeString = (seconds: number): string => {
    if (seconds === null || seconds === undefined || isNaN(seconds)) {
        return '00:00';
    }

    const validSeconds = Math.max(0, Math.min(86399, seconds));
    const hours = Math.floor(validSeconds / 3600);
    const minutes = Math.floor((validSeconds % 3600) / 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

// Convert seconds to moment object with proper AM/PM format
export const convertSecondsToMoment = (seconds: number): moment.Moment => {
    const timeString = convertSecondsToTimeString(seconds);
    return moment(timeString, 'HH:mm');
};

// Convert moment object back to seconds
export const convertMomentToSeconds = (momentObj: moment.Moment): number => {
    if (!momentObj || !momentObj.isValid()) return 0;

    const hours = momentObj.hours();
    const minutes = momentObj.minutes();
    return (hours * 3600) + (minutes * 60);
};

// Format seconds since midnight as "11:00 AM" for display
export const formatSecondsToDisplayTime = (seconds: number): string => {
    const m = convertSecondsToMoment(seconds);
    return m.isValid() ? m.format("h:mm A") : "—";
};
export const formatTimeAgo = (timestamp: number) => {
  const now = moment();
  const inputTime = moment(timestamp);

  const diffInMinutes = now.diff(inputTime, "minutes");
  const diffInHours = now.diff(inputTime, "hours");
  const diffInDays = now.diff(inputTime, "days");
  const diffInWeeks = now.diff(inputTime, "weeks");
  const diffInMonths = now.diff(inputTime, "months");
  const diffInYears = now.diff(inputTime, "years");

  if (diffInMinutes < 1) {
    return "Just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} min ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} hours ago`;
  } else if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
  } else if (diffInWeeks < 4) {
    return `${diffInWeeks} week${diffInWeeks > 1 ? "s" : ""} ago`;
  } else if (diffInMonths < 12) {
    return `${diffInMonths} month${diffInMonths > 1 ? "s" : ""} ago`;
  } else {
    return `${diffInYears} year${diffInYears > 1 ? "s" : ""} ago`;
  }
};

export const convertDateToSeconds = (date: any) => {
    // Parse the date in UTC to avoid timezone issues
    const momentDate = moment.utc(date);
    const hours = momentDate.hour();
    const minutes = momentDate.minute();
    return hours * 3600 + minutes * 60;
};

export const formatDate = (date: number) =>
  new Date(date).toLocaleString("default", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

export const convertWithTime = (milliseconds: number) => {
  return moment(milliseconds).format("h:mm a");
};

export const convertDateToTimeStamp = (date: any) => {
  const formatDate: any = moment(date).format("MM-DD-YYYY");
  const timestamp = moment(formatDate).valueOf();
  return timestamp;
};

export const formatDateTime = (date: number) =>
  new Date(date).toLocaleString("default", {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

/** Short format: 02/15/2026 1:14 am */
export const formatShortDateTime = (timestamp: number) =>
  moment(timestamp).format("MM/DD/YYYY h:mm a");

/** Date and time parts for hierarchy (date = primary, time = muted). */
export const formatShortDate = (timestamp: number) =>
  moment(timestamp).format("MM/DD/YYYY");
export const formatShortTime = (timestamp: number) =>
  moment(timestamp).format("h:mm A");
